import React from "react";
import { useParams } from "react-router-dom";

import { HubTableTemplate } from "../../components";
import { useGetWorkOrderData } from "../../hooks";
import { condition, items, keys } from "./helper";

import WorkOrderRoutingLabor from "./WorkOrderRoutingLabor";

export const WorkOrderRoutingTable = () => {
  const { id } = useParams();
  const { data } = useGetWorkOrderData(id);
  const { routing, currentRoute } = data;

  const rows = routing?.map((r) => ({
    ...r,
    isCurrent: r?.id === currentRoute,
    isDone: r?.endDate,
  }));

  const headerProps = { items };
  const bodyProps = {
    items: rows,
    keys,
    condition,
    RenderElement: WorkOrderRoutingLabor,
    name: "routes",
    includeChevron: true,
  };
  const props = { headerProps, bodyProps, isFormTable: true };

  return <HubTableTemplate id="WorkOrderRouting" {...props} />;
};

export default WorkOrderRoutingTable;
